let coll = document.getElementsByClassName("collapsible");
let i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    let content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}

function attachUpsellToggle() {
    var heading = document.querySelector('.M-cart-upsell-heading');
    var wrapper = document.querySelector('.M-cart-upsell-wrapper');
    
    if (heading && wrapper) {
      heading.addEventListener('click', function() {
        wrapper.classList.toggle('hide-upsell');
      });
    }
  }
$(document).ready(function() {
  function showPopup() {
    $('.msize-popup').addClass('show-popup');
    $('.shopify-section-group-header-group').each(function() {
      $(this).addClass('mpopup-enable');
    });
  }
  function hidePopup() {
    $('.msize-popup').removeClass('show-popup');
    $('.shopify-section-group-header-group').each(function() {
      $(this).removeClass('mpopup-enable');
    });
  }
  $('.size-shart-toggle').on('click', showPopup);
  $('.msize-close').on('click', hidePopup);
});


initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});

$(document).on('shopify:section:unload', function(event) {
 initslide();
});
function initslide() {
$('.M-trustpilot-slider').slick({
   infinite: true,
   slidesToShow: 2,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 3000,
     prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
  responsive: [
   {
      breakpoint: 900,
      settings: {
        arrows: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
   },
   {
      breakpoint: 600,
      settings: {
        arrows: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
   }
  ]
  });
}

    function cartUpsell() {
      $('.M-cart-upsell-collection').slick({
      infinite: false,
      speed: 600,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false
    });
  }

function servicesSlider(id, num) {
    $(id).slick({
     infinite: false,
     speed: 300,
     slidesToShow: num,
     slidesToScroll: 1,
     arrows: false,
     responsive: [
       {
         breakpoint: 1200,
         settings: {
           slidesToShow: 3,
           dots: true
         }
       }, 
       {
         breakpoint: 991,
         settings: {
           slidesToShow: 2,
           dots: true
         }
       },
         {
         breakpoint: 767,
         settings: {
           slidesToShow: 1,
           dots: true
         }
       }
     ]
   });
 }

function gridimage(productId, img, clickedElement) {
  var mainDivSelector = '.mcard-product-' + productId;
  var colorBoxSelector = mainDivSelector + ' .mgrid-color-box';
  var elements = document.querySelectorAll(colorBoxSelector);
  elements.forEach(function(element) {
    element.classList.remove('colorActive');
  });
  clickedElement.classList.add('colorActive');
  var imageSelector = mainDivSelector + ' .mcard-image-' + productId;
  var element = document.querySelector(imageSelector);
  if (element) {
    element.src = img;
  } 
}
function updateCounter(id, min, max, int) {
    let counter = document.getElementById(id);
    let count = parseInt(localStorage.getItem("count")) || parseInt(min);
    min = parseInt(min);
    max = parseInt(max);
    int = parseInt(int);
  
    function updateCount() {
      let randomNum = Math.random() < 0.5 ? Math.floor(Math.random() * 5) + 1 : Math.floor(Math.random() * 10) + 1;
      let randomSign = Math.random() < 0.7 ? 1 : -1;
      count += randomNum * randomSign;
      count = Math.max(min, Math.min(max, count));
      counter.textContent = count;
      localStorage.setItem("count", count);
    }
  
    setInterval(updateCount, int);
    updateCount();
  }